import $ from 'jquery';
export default function edvCustomizeUltimateMember() {
    $('label[for="confirm_user_password"]').text('Password bestätigen *');
    $('label[for="user_password"]').text('Passwort festlegen *');

}